export const SOURCE_ACTIONS = {
    SET_SOURCE: "SET_SOURCE",
    SET_IS_LOADING: "SET_IS_LOADING",
}